import "./PatternPaletteHome.css";
import PatternSwatches from "./PatternSwatches";

const PatternPaletteHome = () => {
  return (
    <div className="palettePatternHomeContainer">
      <div className="patternInstructions">
        <p className="patternInstructionText">
          • Select the pattern you want to modify
        </p>
        <p className="patternInstructionText">
          • Click on pattern element you want to change color
        </p>
        <p className="patternInstructionText">
          • Click the color swatch you want to apply to the element
        </p>
      </div>

      <PatternSwatches />
    </div>
  );
};

export default PatternPaletteHome;
